import { render, staticRenderFns } from "./ApprovePin.vue?vue&type=template&id=be0d8666"
import script from "./ApprovePin.vue?vue&type=script&lang=js"
export * from "./ApprovePin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports